import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { updateCacheByType } from "../../../graphql/GraphQlProvider";
import { StatusMessage } from "../../../graphql/common.datatypes";

export interface UpdateNoteInput {
    data: {
        id: number;
        note: string;
    };
}

interface UpdateNoteData {
    updateNote: StatusMessage;
}

export const UpdateNoteMutation = gql`
    mutation updateNoteMutation($data: UpdateNoteInput!) {
        updateNote(data: $data) {
            id
            user_id
            group_id
            room_party_id
            billing_party_id
            group_member_id
            note
            created_at
            updated_at
        }
    }
`;

export const updateNote = () =>
    useMutation<UpdateNoteData, UpdateNoteInput>(UpdateNoteMutation, {
        update: updateCacheByType("Note")
    });

export default updateNote;
